/* Held & Smooth / posture landing: progressive, scoped interactions. */
(function(){
  'use strict';
  var gallery=document.querySelector('[data-gallery]');
  var buttons=gallery?Array.from(gallery.querySelectorAll('[data-gallery-thumb]')):[];
  function showImage(button){
    if(!gallery||!button)return;
    var main=gallery.querySelector('[data-gallery-main]');
    var duo=gallery.querySelector('[data-gallery-duo]');
    var video=gallery.querySelector('[data-gallery-video]');
    var isDuo=button.hasAttribute('data-duo');
    var isVideo=button.hasAttribute('data-video');
    if(video){
      video.hidden=!isVideo;
      if(isVideo){try{video.currentTime=0;video.play();}catch(e){}}
      else{try{video.pause();}catch(e){}}
    }
    if(main&&duo){
      if(isVideo){main.hidden=true;duo.hidden=true;}
      else if(isDuo){main.hidden=true;duo.hidden=false;}
      else if(button.dataset.src){main.src=button.dataset.src;main.alt=button.dataset.alt||'Posture corrector';main.hidden=false;duo.hidden=true;}
    }
    buttons.forEach(function(b){b.classList.toggle('is-active',b===button);b.setAttribute('aria-pressed',String(b===button));});
  }
  buttons.forEach(function(b){b.setAttribute('aria-pressed',String(b.classList.contains('is-active')));b.addEventListener('click',function(){showImage(b);});});
  var root=document.querySelector('[data-product-root]');
  if(root){
    var json=root.querySelector('[data-variants-json]');
    var variants=[];if(json){try{variants=JSON.parse(json.textContent);}catch(e){variants=[];}}
    var form=root.querySelector('form[action*="/cart/add"]');
    var idInput=form&&form.querySelector('input[name="id"]');
    var btn=root.querySelector('[data-add-button]');
    var buyNow=root.querySelector('[data-buy-now]');
    var addTotal=root.querySelector('[data-add-total]');
    var stickyButtons=Array.from(document.querySelectorAll('[data-sticky-add]'));
    var feedback=root.querySelector('[data-cart-feedback]');
    var price=root.querySelector('[data-price]');
    var stickyPrices=Array.from(document.querySelectorAll('[data-sticky-price]'));
    var stickyCompares=Array.from(document.querySelectorAll('[data-sticky-compare]'));
    var stickySaves=Array.from(document.querySelectorAll('[data-sticky-save]'));
    var stickyOptions=Array.from(document.querySelectorAll('[data-sticky-options]'));
    var stickyOptionButtons=Array.from(document.querySelectorAll('[data-sticky-option-button]'));
    var stickyImages=Array.from(document.querySelectorAll('[data-sticky-image]'));
    var compare=root.querySelector('[data-compare]');
    var saveBadge=root.querySelector('[data-save-badge]');
    var quantityField=form&&form.querySelector('[data-form-quantity]');
    var quantityInputs=Array.from(root.querySelectorAll('[data-quantity-choice]'));
    var oneMeta=root.querySelector('[data-quantity-single-meta]');
    var twoMeta=root.querySelector('[data-quantity-double-meta]');
    var threeMeta=root.querySelector('[data-quantity-triple-meta]');
    var current=null,busy=false;
    var regularPriceCents=Number(root.dataset.regularPriceCents||2999);
    function money(cents){
      if(window.Shopify&&typeof window.Shopify.formatMoney==='function')return Shopify.formatMoney(cents,root.dataset.moneyFormat);
      var fmt=root.dataset.moneyFormat||'${{amount}}';
      var amount=(Number(cents)/100).toFixed(2);
      return fmt.replace(/\{\{\s*(amount|amount_with_comma_separator|amount_no_decimals|amount_no_decimals_with_comma_separator)\s*\}\}/g,function(_,kind){var dec=kind.indexOf('no_decimals')!==-1;var v=dec?String(Math.round(Number(cents)/100)):amount;return kind.indexOf('comma_separator')!==-1?v.replace('.',','):v;});
    }
    function selectedQuantity(){var selected=quantityInputs.find(function(i){return i.checked;});return selected?Number(selected.value):1;}
    function selectedDiscount(){var selected=quantityInputs.find(function(i){return i.checked;});return selected?Number(selected.dataset.discount||0):0;}
    function bundleTotal(unitPrice,qty,discount){return Math.round(Number(unitPrice)*Number(qty)*(1-(Number(discount)||0)/100));}
    function chosenOptions(){return Array.from(root.querySelectorAll('[data-option-position]')).sort(function(a,b){return Number(a.dataset.optionPosition)-Number(b.dataset.optionPosition);}).map(function(group){var picked=group.querySelector('input[data-option-value]:checked');return picked?picked.value:null;});}
    function syncStickyControls(picked){stickyOptionButtons.forEach(function(button){var idx=Number(button.dataset.optionPosition)-1;var selected=picked[idx]!=null&&String(picked[idx])===String(button.dataset.value);button.classList.toggle('is-selected',selected);button.setAttribute('aria-pressed',String(selected));});}
    function update(changeImage){
      if(!variants.length)return;
      var picked=chosenOptions();
      syncStickyControls(picked);
      current=variants.find(function(v){return v.options.length===picked.length&&v.options.every(function(o,i){return o===picked[i];});})||null;
      if(idInput)idInput.value=current?current.id:'';
      var qty=selectedQuantity();
      var bundleDiscount=selectedDiscount();
      var selectedTotal=current?bundleTotal(current.price,qty,bundleDiscount):0;
      if(price&&current)price.textContent=money(selectedTotal);
      if(current){
        var one=root.querySelector('[data-quantity-single-price]');
        var two=root.querySelector('[data-quantity-double-price]');
        var three=root.querySelector('[data-quantity-triple-price]');
        if(one)one.textContent=money(current.price);
        if(two)two.textContent=money(bundleTotal(current.price,2,10));
        if(three)three.textContent=money(bundleTotal(current.price,3,20));
        if(oneMeta)oneMeta.textContent=money(current.price)+' each';
        if(twoMeta)twoMeta.textContent=money(Math.round(bundleTotal(current.price,2,10)/2))+' each';
        if(threeMeta)threeMeta.textContent=money(Math.round(bundleTotal(current.price,3,20)/3))+' each';
      }
      if(quantityField)quantityField.value=String(qty);
      if(current)stickyPrices.forEach(function(el){el.textContent=money(selectedTotal);});
      if(compare&&current){
        var unitRegular=(Number(current.compare_at_price)>Number(current.price))?Number(current.compare_at_price):regularPriceCents;
        var regularTotal=unitRegular*qty;
        compare.textContent=money(regularTotal);
        compare.hidden=false;
        stickyCompares.forEach(function(el){el.textContent=money(regularTotal);});
        if(saveBadge){
          var totalPct=regularTotal>selectedTotal?Math.round(((regularTotal-selectedTotal)/regularTotal)*100):0;
          saveBadge.textContent=totalPct>0?'SAVE '+totalPct+'%':'LIMITED OFFER';
          saveBadge.hidden=false;
          stickySaves.forEach(function(el){el.textContent=totalPct>0?'SAVE '+totalPct+'%':'LIMITED OFFER';});
        }
      }
      if(current&&stickyOptions.length){
        var selectedOptions=picked.filter(Boolean).join(' / ');
        stickyOptions.forEach(function(el){el.textContent=selectedOptions||current.title||'Selected option';});
      }
      if(stickyImages.length){
        var colorIndex=Array.from(root.querySelectorAll('[data-option-position]')).findIndex(function(group){var label=group.querySelector('legend');return label&&/colou?r|renk/i.test(label.textContent);});
        var selectedColor=colorIndex>=0?String(picked[colorIndex]||'').toLowerCase():'';
        stickyImages.forEach(function(img){
          var nextSrc='';
          if(selectedColor.includes('pink')&&img.dataset.imagePink)nextSrc=img.dataset.imagePink;
          else if(selectedColor.includes('black')&&img.dataset.imageBlack)nextSrc=img.dataset.imageBlack;
          else if(current&&current.featured_image&&current.featured_image.src)nextSrc=current.featured_image.src;
          else nextSrc=img.dataset.imageFallback||img.getAttribute('src')||'';
          if(nextSrc)img.src=nextSrc;
          if(selectedColor){img.alt=(selectedColor.charAt(0).toUpperCase()+selectedColor.slice(1))+' posture support';}
        });
      }
      var available=!!(current&&current.available);
      if(btn){btn.disabled=busy||!available;var label=btn.querySelector('[data-add-label]')||btn.querySelector('span');if(label)label.textContent=available?'ADD TO CART':'SOLD OUT';if(addTotal&&current)addTotal.textContent=money(selectedTotal);}
      if(buyNow)buyNow.disabled=busy||!available;
      stickyButtons.forEach(function(sticky){sticky.disabled=busy||!available;});
      if(changeImage&&gallery){
        var colorIndex=Array.from(root.querySelectorAll('[data-option-position]')).findIndex(function(group){var label=group.querySelector('legend');return label&&/colou?r|renk/i.test(label.textContent);});
        var color=colorIndex>=0?String(picked[colorIndex]||'').toLowerCase():'';
        var thumb=color.includes('black')?buttons.find(function(b){return b.dataset.color==='black';}):color.includes('pink')?buttons.find(function(b){return b.dataset.color==='pink';}):null;
        if(thumb)showImage(thumb);
      }
      if(current&&root.dataset.updateUrl==='true'&&window.history){var u=new URL(location.href);u.searchParams.set('variant',String(current.id));history.replaceState(null,'',u.toString());}
    }
    quantityInputs.forEach(function(input){input.addEventListener('change',function(){quantityInputs.forEach(function(i){i.closest('label').classList.toggle('is-selected',i.checked);});update(false);});});
    root.querySelectorAll('[data-option-value]').forEach(function(input){input.addEventListener('change',function(){update(true);if(feedback)feedback.textContent='';});});
    stickyOptionButtons.forEach(function(button){button.addEventListener('click',function(){var position=String(button.dataset.optionPosition);var value=String(button.dataset.value);var group=root.querySelector('[data-option-position="'+position+'"]');if(!group)return;var target=Array.from(group.querySelectorAll('input[data-option-value]')).find(function(input){return String(input.value)===value;});if(target){target.checked=true;target.dispatchEvent(new Event('change',{bubbles:true}));}});});
    function setMessage(message,error){if(feedback){feedback.classList.toggle('is-error',!!error);feedback.textContent=message;}}
    if(buyNow){buyNow.addEventListener('click',function(){
      if(busy||!current||!current.available){setMessage('Choose an available color and size first.',true);return;}
      busy=true;update(false);buyNow.textContent='OPENING CHECKOUT…';setMessage('',false);
      var base=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
      fetch(base+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(current.id),quantity:selectedQuantity()}]})})
      .then(function(res){if(!res.ok)return res.json().catch(function(){return null;}).then(function(j){throw new Error(j&&(j.description||j.message)||'Could not start checkout.');});return res.json();})
      .then(function(){window.location.href=base+'checkout';})
      .catch(function(err){busy=false;buyNow.textContent='BUY NOW';update(false);setMessage(err.message||'Could not start checkout.',true);});
    });}
    if(form){form.addEventListener('submit',function(evt){
      evt.preventDefault();
      if(busy||!current||!current.available){setMessage('Choose an available color and size first.',true);return;}
      busy=true;update(false);if(btn){var label=btn.querySelector('[data-add-label]')||btn.querySelector('span');if(label)label.textContent='ADDING…';}setMessage('Adding to your bag…',false);
      var base=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
      fetch(base+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(current.id),quantity:selectedQuantity()}]})})
      .then(function(res){if(!res.ok)return res.json().catch(function(){return null;}).then(function(j){throw new Error(j&&(j.description||j.message)||'Could not add this item.');});return res.json();})
      .then(function(){return fetch(base+'cart.js',{credentials:'same-origin'});})
      .then(function(res){return res.ok?res.json():null;})
      .then(function(cart){if(cart)document.querySelectorAll('[data-posture-cart-count]').forEach(function(el){el.textContent=cart.item_count;});setMessage('Added to your cart. You can continue shopping or go to checkout.',false);})
      .catch(function(err){setMessage(err.message||'Something went wrong. Please try again.',true);})
      .finally(function(){busy=false;update(false);});
    });}
    stickyButtons.forEach(function(sticky){if(form){sticky.addEventListener('click',function(){if(btn&&!btn.disabled){form.requestSubmit?form.requestSubmit(btn):btn.click();}else{document.getElementById('choose-your-support')?.scrollIntoView({behavior:'smooth'});}});}});
    update(false);
    var stickyBars=Array.from(document.querySelectorAll('[data-mobile-bar],[data-sticky-bar]'));
    var stickyTrigger=root.closest('.posture-product')||document.getElementById('choose-your-support')||btn;
    if(stickyBars.length&&stickyTrigger){
      if('IntersectionObserver' in window){
        var atcObserver=new IntersectionObserver(function(entries){
          entries.forEach(function(e){
            stickyBars.forEach(function(bar){bar.classList.toggle('is-visible',!e.isIntersecting);});
          });
        },{threshold:.08});
        atcObserver.observe(stickyTrigger);
      }else{
        stickyBars.forEach(function(bar){bar.classList.add('is-visible');});
      }
    }
  }

  function initSaleCountdowns(){
    var nodes=Array.from(document.querySelectorAll('[data-countdown]'));
    if(!nodes.length)return;
    function pad(n){return String(Math.max(0,n)).padStart(2,'0');}
    function tick(){
      var now=Date.now();
      nodes.forEach(function(node){
        var wrap=node.closest('[data-sale-end]');
        var raw=wrap&&wrap.dataset.saleEnd;
        var end=raw?Date.parse(raw):NaN;
        var label=node.querySelector('.ps-countdown__label');
        if(!Number.isFinite(end)){if(label)label.textContent='Limited-time offer';return;}
        var diff=end-now;
        if(diff<=0){node.classList.add('is-ended');if(label)label.textContent='Offer ended';return;}
        node.classList.remove('is-ended');if(label)label.textContent='Offer ends in';
        var total=Math.floor(diff/1000),days=Math.floor(total/86400);total%=86400;
        var hours=Math.floor(total/3600);total%=3600;
        var mins=Math.floor(total/60),secs=total%60;
        var d=node.querySelector('[data-countdown-days]'),h=node.querySelector('[data-countdown-hours]'),m=node.querySelector('[data-countdown-minutes]'),sec=node.querySelector('[data-countdown-seconds]');
        if(d)d.textContent=pad(days);if(h)h.textContent=pad(hours);if(m)m.textContent=pad(mins);if(sec)sec.textContent=pad(secs);
      });
    }
    tick();setInterval(tick,1000);
  }
  initSaleCountdowns();

  var revealEls=Array.from(document.querySelectorAll('.posture-funnel .reveal'));
  if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches){revealEls.forEach(function(el){el.classList.add('is-visible');});}
  else if('IntersectionObserver' in window){var revealObserver=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-visible');revealObserver.unobserve(e.target);}});},{rootMargin:'0px 0px -25px 0px',threshold:.07});revealEls.forEach(function(el){revealObserver.observe(el);});}
  else revealEls.forEach(function(el){el.classList.add('is-visible');});
})();
